import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import PageBanner from '../components/PageBanner';
import Pricing from '../components/Pricing';

const PricingPage = () => {
  const { t } = useLang();
  return (
    <>
      <PageBanner tag={t.pricing.tag} title={t.pricing.title} />
      <Pricing hideHeader />
    </>
  );
};

export default PricingPage;
